// extracted by mini-css-extract-plugin
module.exports = {"section_container":"_3E5ZQse","court_action_container":"_3RbKwOH","court_action_table":"_1K8Xe_Y","court_action_amount":"_24WIRlB","collections_table":"_3Ywst5p"};